import { useEffect, useState } from "react";
import {
  ActionButton,
  Button,
  ContractCard,
  HeaderRow,
  ModalButtons,
  ModalContent,
  ModalOverlay,
  ModalTextarea,
  MyContractsStyle,
  RowMyContractsDetails,
  SubTitle,
  WrapContent,
} from "../../styles/MyContracts";
import { IoArrowBackOutline } from "react-icons/io5";
import { CiCirclePlus } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import {
  HOME_LOGGED,
  SELECTPLANMODIFICATION,
  TYPEREGISTER,
} from "../../core/app-urls";
import {
  cancelPlan,
  getContractsDetails,
  getContractsPF,
  sendChangePlanNotification,
} from "../../data/services/person_service";
import { toast, ToastContainer } from "react-toastify";
import ContractInfoModel from "../../data/models/contractInfoPF";

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export default function MyContracts() {
  const navigate = useNavigate();
  const [contracts, setContracts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [selectedContractId, setSelectedContractId] = useState<number | null>(
    null
  );
  const [contractDetailsMap, setContractDetailsMap] = useState<
    Record<number, ContractInfoModel>
  >({});

  const fetchContracts = async () => {
    setLoading(true);
    const response = await getContractsPF();
    if (response.data) {
      const sortedContracts = [...response.data].sort((a, b) => {
        const dateA = new Date(a.dataContrato).getTime();
        const dateB = new Date(b.dataContrato).getTime();
        return dateB - dateA;
      });
      setContracts(sortedContracts);
    } else {
      console.error("Não foi possível carregar os contratos.");
    }
    setLoading(false);
  };

  const fetchContractDetail = async (contractId: number) => {
    if (contractDetailsMap[contractId]) return;

    const response = await getContractsDetails(contractId.toString());
    if (response.data) {
      setContractDetailsMap((prev) => ({
        ...prev,
        [contractId]: response.data!,
      }));
    }
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  const handleClick = () => {
    navigate(TYPEREGISTER);
  };

  const handlePlanModification = async (
    idConvenio: number,
    idClube: number,
    idContrato: number,
    contractID: number
  ) => {
    if (idConvenio != null) {
      navigate(SELECTPLANMODIFICATION, {
        state: { idClube, idConvenio, idContrato, contractID },
      });
    } else {
      const response = await sendChangePlanNotification(idContrato);
      if (response) {
        navigate(TYPEREGISTER);
      } else {
        toast.error("Ocorreu um problema, tente novamente mais tarde!");
      }
    }
  };

  const handleCancelationClick = (contract_id: number) => {
    setSelectedContractId(contract_id);
    setShowModal(true);
  };

  const handleConfirmCancelation = async () => {
    if(reason.trim() == ""){
      alert('Adicione o motivo do cancelamento.')
    }

    if (selectedContractId !== null && reason.trim() !== "") {
      try {
        const response = await cancelPlan(selectedContractId, 12, reason);
        toast.success('Solicitação de cancelamento enviada com sucesso!');
        setShowModal(false);
        setReason("");
        setSelectedContractId(null);
        fetchContracts();
      } catch (error) {
        console.error("Erro ao cancelar plano:", error);
        toast.error("Ocorreu um erro ao tentar cancelar o plano.");
      }
    }
  };

  const toggleExpand = async (index: number, contractId: number) => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
    } else {
      await fetchContractDetail(contractId);
      setExpandedIndex(index);
    }
  };

  return (
    <MyContractsStyle>
      <ToastContainer />
      <WrapContent>
        <HeaderRow onClick={() => navigate(HOME_LOGGED)}>
          <IoArrowBackOutline size={24} />
          <h1>Meus contratos</h1>
        </HeaderRow>
        <SubTitle>Clique no plano para exibir mais detalhes.</SubTitle>
        <Button onClick={handleClick}>
          <CiCirclePlus size={35} />
          Nova Adesão
        </Button>

        {loading ? (
          <p>Carregando contratos...</p>
        ) : (
          contracts.map((contract, index) => {
            const isExpanded = expandedIndex === index;
            const details = contractDetailsMap[contract.idContrato];

            return (
              <ContractCard
                key={index}
                onClick={() => {
                  // TODO TROCAR COMPARAÇÃO ABAIXO PARA O CORRETO: !contract
                  if (
                    !contract.dtCancelamento &&
                    contract.idStatusContrato !== 3
                  ) {
                    toggleExpand(index, contract.idContrato);
                  }
                }}
                $expanded={isExpanded}
                style={{
                  opacity:
                    contract.dtCancelamento || contract.idStatusContrato == 3
                      ? 0.6
                      : 1,
                  cursor:
                    contract.dtCancelamento || contract.idStatusContrato == 3
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h1>Contrato: {contract.numero_contrato}</h1>
                    <h1>{formatDate(contract.dataContrato)}</h1>
                  </div>

                  {isExpanded && (
                    <RowMyContractsDetails>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                        }}
                      >
                        <h4>Nome: {details?.nomeAssociado || "..."}</h4>
                        <h4>Plano: {details?.plano || "..."}</h4>
                        <h4>Clube: {details?.clube || "..."}</h4>
                      </div>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          gap: "10px",
                          flexDirection: "column",
                        }}
                      >
                        <ActionButton
                          onClick={() =>
                            handleCancelationClick(contract.idContrato)
                          }
                        >
                          Solicitar Desativação do Plano
                        </ActionButton>
                        <ActionButton
                          onClick={() =>
                            handlePlanModification(
                              details.idConvenio!,
                              details.idClube,
                              contract.numero_contrato,
                              details.idContrato
                            )
                          }
                        >
                          Solicitar Alteração no Plano
                        </ActionButton>
                      </div>
                    </RowMyContractsDetails>
                  )}
                </div>
              </ContractCard>
            );
          })
        )}
      </WrapContent>

      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <h2>Motivo do cancelamento</h2>
            <ModalTextarea
              placeholder="Digite o motivo"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            <ModalButtons>
              <button onClick={() => setShowModal(false)}>Cancelar</button>
              <button onClick={handleConfirmCancelation}>Confirmar</button>
            </ModalButtons>
          </ModalContent>
        </ModalOverlay>
      )}
    </MyContractsStyle>
  );
}
